/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhotoResponse
 */
export interface PhotoResponse {
    /**
     * 
     * @type {string}
     * @memberof PhotoResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoResponse
     */
    legend?: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoResponse
     */
    baseUrl: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoResponse
     */
    absoluteUrl: string;
}

/**
 * Check if a given object implements the PhotoResponse interface.
 */
export function instanceOfPhotoResponse(value: object): value is PhotoResponse {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('baseUrl' in value) || value['baseUrl'] === undefined) return false;
    if (!('absoluteUrl' in value) || value['absoluteUrl'] === undefined) return false;
    return true;
}

export function PhotoResponseFromJSON(json: any): PhotoResponse {
    return PhotoResponseFromJSONTyped(json, false);
}

export function PhotoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhotoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'legend': json['legend'] == null ? undefined : json['legend'],
        'baseUrl': json['baseUrl'],
        'absoluteUrl': json['absoluteUrl'],
    };
}

export function PhotoResponseToJSON(value?: PhotoResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'legend': value['legend'],
        'baseUrl': value['baseUrl'],
        'absoluteUrl': value['absoluteUrl'],
    };
}

